import React, { useState } from 'react';
import { Box, Paper, Typography, Chip, Avatar } from '@mui/material';
import { useKBTheme } from '../../hooks/useKBTheme';
import { mockTickets } from '../../data/mockData';

export const DemoTicketBoard: React.FC = () => {
  const { mode } = useKBTheme();
  const [tickets] = useState(mockTickets);

  const columns = [
    { id: 'open', title: 'Open', color: '#6366f1' },
    { id: 'in_progress', title: 'In Progress', color: '#8b5cf6' },
    { id: 'resolved', title: 'Resolved', color: '#10b981' },
    { id: 'closed', title: 'Closed', color: '#64748b' },
  ];

  const getTicketsByStatus = (status: string) => {
    return tickets.filter((t) => t.status === status);
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, overflowX: 'auto', pb: 2 }}>
      {columns.map((column) => {
        const columnTickets = getTicketsByStatus(column.id);
        return (
          <Box key={column.id} sx={{ minWidth: 280, flexShrink: 0 }}>
            <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  bgcolor: column.color,
                }}
              />
              <Typography variant="h6" sx={{ fontWeight: 600, color: mode === 'dark' ? '#fff' : '#0f172a' }}>
                {column.title}
              </Typography>
              <Chip
                label={columnTickets.length}
                size="small"
                sx={{
                  bgcolor: mode === 'dark' ? 'rgba(71, 85, 105, 0.4)' : 'rgba(241, 245, 249, 0.8)',
                  color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#64748b',
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {columnTickets.map((ticket) => (
                <Paper
                  key={ticket.id}
                  sx={{
                    p: 2,
                    cursor: 'pointer',
                    background: mode === 'dark' ? 'rgba(71, 85, 105, 0.4)' : 'rgba(255, 255, 255, 0.8)',
                    border: `1px solid ${mode === 'dark' ? 'rgba(71, 85, 105, 0.6)' : 'rgba(226, 232, 240, 0.8)'}`,
                    borderRadius: 2,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: mode === 'dark'
                        ? '0 8px 24px rgba(0, 0, 0, 0.3)'
                        : '0 8px 24px rgba(15, 23, 42, 0.1)',
                    },
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: mode === 'dark' ? '#fff' : '#0f172a' }}>
                    {ticket.summary}
                  </Typography>
                  <Typography variant="caption" sx={{ color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#64748b', mb: 1.5, display: 'block' }}>
                    {ticket.description.substring(0, 60)}...
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                    <Chip
                      label={ticket.priority}
                      size="small"
                      sx={{
                        bgcolor: ticket.priority === 'high' ? '#ef4444' : ticket.priority === 'medium' ? '#f59e0b' : '#10b981',
                        color: '#fff',
                        fontSize: '0.7rem',
                      }}
                    />
                    {ticket.assigned_to && (
                      <Avatar sx={{ width: 20, height: 20, fontSize: '0.6rem' }}>
                        {ticket.assigned_to.charAt(0).toUpperCase()}
                      </Avatar>
                    )}
                  </Box>
                </Paper>
              ))}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};








